import { Pipe, PipeTransform } from '@angular/core';
import { InputAttribute } from '../../app.model';

@Pipe({
  name: 'selectalltables'
})
export class SelectAllTablesPipe implements PipeTransform {

  transform(inputAttributes: any[], dataSourceType: string, currentSelection: any, currentStep: any): boolean {

    let selectionKey = (inputAttribute: InputAttribute, currentStep: any) : string => {
      return dataSourceType + '.input.' + (currentStep + 1) + '.' + inputAttribute?.name;
    }
    
    if(dataSourceType === 'GOOGLEADS') {
      let atleastOneFromEachGoogleAdsInputAttributeMap: Map<string, boolean> = new Map<string, boolean>();
      inputAttributes.filter((inputAttribute: any) => {
        return inputAttribute.type != 'HIDDEN'
      }).forEach((inputAttribute: any) => {
        inputAttribute?.childAttribute?.forEach( (childAttribute: any) => {
            if ( childAttribute?.possibleValues?.length == 0 && childAttribute?.childAttribute?.length > 0 ) {
              childAttribute?.childAttribute?.forEach( (child: any) => {
                if (child?.possibleValues?.length > 0 && child?.childAttribute?.length == 0) {
                  let allSelected = false;
                  if(currentSelection[selectionKey(inputAttribute, currentStep)] && currentSelection[selectionKey(inputAttribute, currentStep)]?.length > 0 ){
                    allSelected = child?.possibleValues?.every( (possibleValue: any) => {
                      return currentSelection[selectionKey(inputAttribute, currentStep)]?.includes(possibleValue?.value);
                    });
                  }
                  atleastOneFromEachGoogleAdsInputAttributeMap.set(`${inputAttribute?.label}-${childAttribute?.label}-${child?.label}`, allSelected);
                }
              });
            } else if( childAttribute.label === 'Metrics' && childAttribute?.possibleValues?.length > 0 && childAttribute?.childAttribute?.length == 0){
              let allSelected = false;
              allSelected = childAttribute?.possibleValues?.every( (possibleValue: any) => {
                return currentSelection[selectionKey(inputAttribute, currentStep)]?.includes(possibleValue?.value);
              });
              atleastOneFromEachGoogleAdsInputAttributeMap.set(`${inputAttribute?.label}-${childAttribute?.label}`, allSelected);
            }
          });
      })
      return Array.from(atleastOneFromEachGoogleAdsInputAttributeMap.values()).every((value: boolean) => {
        return value === true
      })
    } else if(dataSourceType === 'BINGADS') {
      let bingAdsTablesWithMutuallyExclusiveColumns = inputAttributes.filter(inputAttribute => {
        return inputAttribute.type != 'HIDDEN' && inputAttribute.hasMutualExclusiveColumn == true
      }).map((attribute)=>{
        return attribute.label;
      });
      return inputAttributes.filter((inputAttribute: any) => {
        return inputAttribute.type != 'HIDDEN'
      }).every((inputAttribute: any) => {
        if(bingAdsTablesWithMutuallyExclusiveColumns.includes(inputAttribute.label) ){
          return true;
        } else {
          return inputAttribute.selected === true
        }
      });
    }
    return false;
  }
}
